import React from 'react'

class AppApplyRecordPage extends React.Component {
    render() {
        return (
            <div style={{width: '100%', height: '100vh', backgroundColor: '#fff', textAlign: 'center'}}>
                暂无订单
            </div>
        )
    }
}

export default AppApplyRecordPage


// WEBPACK FOOTER //
// ./src/pages/AppApplyRecordPage.js